import { render } from "./VLot.vue?vue&type=template&id=50a1543a"
import script from "./VLot.vue?vue&type=script&lang=js"
export * from "./VLot.vue?vue&type=script&lang=js"

import "./VLot.vue?vue&type=style&index=0&id=50a1543a&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__